import { render, staticRenderFns } from "./EditSizeConfiguration.vue?vue&type=template&id=0eae5d50&scoped=true"
import script from "./EditSizeConfiguration.vue?vue&type=script&lang=js"
export * from "./EditSizeConfiguration.vue?vue&type=script&lang=js"
import style0 from "./EditSizeConfiguration.vue?vue&type=style&index=0&id=0eae5d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eae5d50",
  null
  
)

export default component.exports